// src/pages/Home.jsx
import React, { useState } from "react";
import { Helmet } from "react-helmet-async";

import {
  Container,
  Row,
  Col,
  Button,
  Card,
  Accordion,
  Carousel,
  Image,
  Form,
} from "react-bootstrap";
import { FaGraduationCap, FaBook } from "react-icons/fa";
import { FaLayerGroup } from "react-icons/fa";
import "./Home.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaChartLine, FaHandshake, FaUsers, FaWordpress } from "react-icons/fa";
import { BookOpen, Target } from "lucide-react"; // course/learning related icons
import { FaFacebookF, FaTwitter, FaLinkedinIn } from "react-icons/fa";
import { FaWpforms, FaFileAlt, FaCheckCircle } from "react-icons/fa";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";

import { FaSearch, FaPaintBrush, FaCode, FaRocket } from "react-icons/fa";
import {
  FaSnowflake,
  FaUser,
  FaDollarSign,
  FaBuilding,
  FaTruck,
  FaPhoneAlt,
} from "react-icons/fa";
import {
  FaUniversity, // For Trusted & Recognized Universities
  FaClock, // For Flexible & Convenient Learning
  FaBookOpen, // For Wide Range of Programs
  FaUserGraduate, // For Personalized Career Guidance
  FaMoneyBillWave, // For Affordable Fee Structure
  FaHeadset, // For Ongoing Student Support
} from "react-icons/fa";

import { FaPlus, FaMinus } from "react-icons/fa"; // ✅ using react-icons
import Admission from "../components/Admission";
import Partner from "../components/Partner";

const Home = () => {
  const schemaData = [
    {
      "@context": "https://schema.org",
      "@type": "EducationalOrganization",
      name: "Bangalore Distance Education",
      url: "https://bangaloredistanceeducation.com/",
      logo: "https://bangaloredistanceeducation.com/images/BDElogo.png",
      founder: {
        "@type": "Person",
        name: "Bangalore Distance Education",
      },
      contactPoint: [
        {
          "@type": "ContactPoint",
          telephone: "+91 9035600400",
          contactType: "Customer Support",
          areaServed: "IN",
          availableLanguage: ["English", "Hindi", "Kannada"],
        },
        {
          "@type": "ContactPoint",
          telephone: "+91 9035600400",
          contactType: "Admissions",
          areaServed: "IN",
          availableLanguage: ["English", "Hindi", "Kannada"],
        },
      ],
      address: {
        "@type": "PostalAddress",
        streetAddress:
          "2nd floor, Patel Muninarayanappa complex, Hennur Bagalur Main Rd, opp. Relaince digital/smart bazaar, near Ovum Hospital, Indradhanush Layout, Kothanur",
        addressLocality: "Bengaluru",
        addressRegion: "Karnataka",
        postalCode: "560077",
        addressCountry: "IN",
      },
      email: "forashutoshsharma@gmail.com",
      description:
        "Bangalore Distance Education offers flexible and career-focused distance learning courses and online degree courses in Bangalore. Enroll in UGC & AICTE-approved programs including MBA, MCA, MCom, MA, BCom, BCA, BBA, and PhD. We provide expert guidance, student support, and affordable education for learners across India.",
    },
    {
      "@context": "https://schema.org",
      "@type": "Course",
      name: "MBA Distance Education",
      educationalCredentialAwarded: "MBA",
      description:
        "Advance your career with an industry-relevant MBA program designed for leadership and strategic growth.",
      provider: {
        "@type": "EducationalOrganization",
        name: "Bangalore Distance Education",
        url: "https://bangaloredistanceeducation.com/",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "Course",
      name: "MCA Distance Education",
      educationalCredentialAwarded: "MCA",
      description:
        "Build a strong career in tech with an MCA program focused on advanced computing, software, and IT skills.",
      provider: {
        "@type": "EducationalOrganization",
        name: "Bangalore Distance Education",
        url: "https://bangaloredistanceeducation.com/",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "Course",
      name: "MCom Distance Education",
      educationalCredentialAwarded: "MCom",
      description:
        "Deepen your expertise in commerce, finance, and accounting with a career-oriented M.Com program.",
      provider: {
        "@type": "EducationalOrganization",
        name: "Bangalore Distance Education",
        url: "https://bangaloredistanceeducation.com/",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "Course",
      name: "MA Distance Education",
      educationalCredentialAwarded: "MA",
      description:
        "Enhance your knowledge in humanities and social sciences with a flexible and academically enriching MA program.",
      provider: {
        "@type": "EducationalOrganization",
        name: "Bangalore Distance Education",
        url: "https://bangaloredistanceeducation.com/",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "Course",
      name: "BCom Distance Education",
      educationalCredentialAwarded: "BCom",
      description:
        "Gain foundational knowledge in accounting, finance, and business to kickstart your career with a B.Com degree.",
      provider: {
        "@type": "EducationalOrganization",
        name: "Bangalore Distance Education",
        url: "https://bangaloredistanceeducation.com/",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "Course",
      name: "BCA Distance Education",
      educationalCredentialAwarded: "BCA",
      description:
        "Start your journey in the IT world with a BCA program focused on programming and software development.",
      provider: {
        "@type": "EducationalOrganization",
        name: "Bangalore Distance Education",
        url: "https://bangaloredistanceeducation.com/",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "Course",
      name: "BBA Distance Education",
      educationalCredentialAwarded: "BBA",
      description:
        "Develop core business and management skills with a BBA program designed for future leaders.",
      provider: {
        "@type": "EducationalOrganization",
        name: "Bangalore Distance Education",
        url: "https://bangaloredistanceeducation.com/",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "Course",
      name: "PhD Distance Education",
      educationalCredentialAwarded: "PhD",
      description:
        "Pursue advanced research with flexible, UGC-approved PhD distance education programs in Bangalore.",
      provider: {
        "@type": "EducationalOrganization",
        name: "Bangalore Distance Education",
        url: "https://bangaloredistanceeducation.com/",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "What is distance education?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Distance education allows you to study remotely without attending regular physical classes, using online learning platforms and resources.",
          },
        },
        {
          "@type": "Question",
          name: "Are the courses UGC-approved?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, we offer programs only from UGC and AICTE-approved universities to ensure credibility and recognition.",
          },
        },
        {
          "@type": "Question",
          name: "Who is eligible for distance education programs?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Eligibility varies by course. Most undergraduate programs require 10+2, while postgraduate courses require a bachelor’s degree.",
          },
        },
        {
          "@type": "Question",
          name: "How do I apply for a course?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "You can apply online by filling out our application form, uploading required documents, and completing the admission process.",
          },
        },
        {
          "@type": "Question",
          name: "Is there any entrance exam required?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Most distance education courses do not require an entrance exam. However, specific programs may have university-level requirements.",
          },
        },
        {
          "@type": "Question",
          name: "Can I study while working full-time?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Absolutely! Distance education is designed to be flexible, allowing you to learn alongside your job or personal commitments.",
          },
        },
        {
          "@type": "Question",
          name: "Will I receive a valid degree certificate?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, upon successful completion, you’ll receive a degree certificate directly from the respective university, which is valid and recognized.",
          },
        },
        {
          "@type": "Question",
          name: "How are the classes conducted?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Classes are conducted online through recorded lectures, study material, and occasional live sessions, depending on the course and university.",
          },
        },
        {
          "@type": "Question",
          name: "What documents are required for admission?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Generally, you’ll need your ID proof, educational certificates (10th, 12th, or graduation), and recent passport-size photos.",
          },
        },
        {
          "@type": "Question",
          name: "Is student support available during the course?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, our support team is available throughout your course duration to help with academic, technical, and administrative queries.",
          },
        },
      ],
    },
  ];

  const getRandomColor = () => {
    const colors = [
      "#28a745",
      "#007bff",
      "#e83e8c",
      "#6f42c1",
      "#fd7e14",
      "#20c997",
    ];
    return colors[Math.floor(Math.random() * colors.length)];
  };

  const people = [
    {
      id: 1,
      name: "Anjali M",

      course: "MBA Student",
      details: "",
      img: "/images/stu1.jpg",
      desc: "Excellent Guidance",
      color: "#4ECDC4", // teal
    },
    {
      id: 2,
      name: "Sumanth R",

      course: "BBA Student",
      img: "/images/stu2.jpg",
      desc: "Affordable & Genuine",
      color: "#FF6B6B", // coral red
    },
    {
      id: 3,
      name: "Priya D",

      course: "MCA Student",
      img: "/images/stu3.jpg",
      desc: "Team player!",
      color: "#FFD166", // warm yellow
    },
    {
      id: 4,
      name: "Ravi Kumar",

      course: "B.Com Student",
      img: "/images/mcom2.jfif",
      desc: "Problem solver!",
      color: "#6A4C93", // deep violet
    },
  ];

  const steps = [
    {
      num: "1",
      title: "Fill the Application Form",
      text: "Submit your basic details and preferred course through our online admission form.",
      icon: <FaWpforms size={50} />, // form icon
    },
    {
      num: "2",
      title: "Document Verification",
      text: "Upload scanned copies of required documents for verification by our admission team.",
      icon: <FaFileAlt size={50} />, // document icon
    },
    {
      num: "3",
      title: "Confirm Admission & Pay Fees",
      text: "Confirm your admission and pay fees securely to complete the enrollment process.",
      icon: <FaCheckCircle size={50} />, // confirmation/payment icon
    },
  ];

  const universities = [
    {
      name: "Subharti University",
      logo: "/images/subharti.png",
    },
    {
      name: "IGNOU",
      logo: "/images/ignou.png",
    },
    {
      name: "Andhra University",
      logo: "/images/andhra.png",
    },
    {
      name: "Amity University",
      logo: "/images/amity.png",
    },
    {
      name: "Lovely Professional University (LPU)",
      logo: "/images/lpu.png",
    },
    {
      name: "Sikkim Manipal University",
      logo: "/images/smu.png",
    },
    {
      name: "Chandigarh University",
      logo: "/images/chandigarh.png",
    },
    {
      name: "Jain University",
      logo: "/images/jain.png",
    },
    {
      name: "Annamalai University",
      logo: "/images/annamalai.png",
    },
    {
      name: "Delhi University (School of Open Learning)",
      logo: "/images/du.png",
    },
    {
      name: "Madras University",
      logo: "/images/madras.png",
    },
  ];

  const data = [
    { icon: <FaChartLine />, number: "100%", label: "Success Rate" },
    { icon: <FaHandshake />, number: "35+", label: "Years Of Service" },
    { icon: <FaUsers />, number: "8k+", label: "Students" },
    { icon: <FaBook />, number: "10+", label: "Courses" },
  ];

  const courses = [
    {
      id: 1,
      title: "MBA",
      description:
        "Advance your career with an industry-relevant MBA program designed for leadership and strategic growth.",
      color: "#FF6B6B",
    },
    {
      id: 2,
      title: "MCA",
      description:
        "Build a strong career in tech with an MCA program focused on advanced computing, software, and IT skills.",
      color: "#4ECDC4",
    },
    {
      id: 3,
      title: "MCOM",
      description:
        "Deepen your expertise in commerce, finance, and accounting with a career-oriented M.Com program.",
      color: "#FFD93D",
    },
    {
      id: 4,
      title: "MA",
      description:
        "Enhance your knowledge in humanities and social sciences with a flexible and academically enriching MA program.",
      color: "#6A4C93",
    },
    {
      id: 5,
      title: "BCOM",
      description:
        "Gain foundational knowledge in accounting, finance, and business to kickstart your career with a B.Com degree.",
      color: "#1A535C",
    },
    {
      id: 6,
      title: "BCA",
      description:
        "Start your journey in the IT world with a BCA program focused on programming, software development.",
      color: "#FF9F1C",
    },
    {
      id: 7,
      title: "BBA",
      description:
        "Develop core business and management skills with a BBA program designed for future leaders.",
      color: "#2EC4B6",
    },
    {
      id: 8,
      title: "PhD",
      description:
        "Pursue advanced research and contribute new knowledge to your field with a flexible and guided Ph.D. program.",
      color: "#E71D36",
    },
  ];

  const blogs = [
    {
      title: "Writing Class",
      image: "https://via.placeholder.com/400x250?text=Writing+Class",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent eget rutrum massa, id pharetra nunc.",
    },
    {
      title: "Crafts Activities",
      image: "https://via.placeholder.com/400x250?text=Crafts+Activities",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent eget rutrum massa, id pharetra nunc.",
    },
    {
      title: "Math Activities",
      image: "https://via.placeholder.com/400x250?text=Math+Activities",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent eget rutrum massa, id pharetra nunc.",
    },
  ];

  const faqData = [
    {
      question: "What is distance education?",
      answer:
        "Distance education allows you to study remotely without attending regular physical classes, using online learning platforms and resources.",
    },
    {
      question: "Are the courses UGC-approved?",
      answer:
        "Yes, we offer programs only from UGC and AICTE-approved universities to ensure credibility and recognition.",
    },
    {
      question: "Who is eligible for distance education programs?",
      answer:
        "Eligibility varies by course. Most undergraduate programs require 10+2, while postgraduate courses require a bachelor’s degree.",
    },
    {
      question: "How do I apply for a course?",
      answer:
        "You can apply online by filling out our application form, uploading required documents, and completing the admission process.",
    },
    {
      question: "Is there any entrance exam required?",
      answer:
        "Most distance education courses do not require an entrance exam. However, specific programs may have university-level requirements.",
    },
    {
      question: "Can I study while working full-time ?",
      answer:
        "Absolutely! Distance education is designed to be flexible, allowing you to learn alongside your job or personal commitments.",
    },
    {
      question: "Will I recieve a valid degree certificate  ?",
      answer:
        "Yes, upon successful completion, you’ll receive a degree certificate directly from the respective university, which is valid and recognized.",
    },
    {
      question: "How are the classes conducted ?",
      answer:
        "Classes are conducted online through recorded lectures, study material, and occasional live sessions, depending on the course and university.",
    },
    {
      question: "What Documents are required for admission?",
      answer:
        "Generally, you’ll need your ID proof, educational certificates (10th, 12th, or graduation), and recent passport-size photos.",
    },
    {
      question: "Is student support available during the course?",
      answer:
        "Yes, our support team is available throughout your course duration to help with academic, technical, and administrative queries.",
    },
  ];

  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const features = [
    {
      icon: <FaUniversity />,
      title: "Trusted & Recognized Universities",
      details:
        "Enroll in UGC and AICTE-approved universities through the best distance education colleges in Bangalore, offering accredited programs that are recognized by employers and industries across India for career growth.",
    },
    {
      icon: <FaClock />,
      title: "Flexible & Convenient Learning",
      details:
        "Study at your own pace with online degree courses in Bangalore, digital content, and remote exams, making it ideal for working professionals, students, and anyone seeking flexible distance education in Bangalore.",
    },
    {
      icon: <FaBookOpen />,
      title: "Wide Range of Programs",
      details:
        "Choose from diploma, undergraduate, and postgraduate courses in management, IT, commerce, and more. Our distance learning courses in Bangalore provide multiple options to suit different career paths and goals.",
    },
    {
      icon: <FaUserGraduate />,
      title: "Personalized Career Guidance",
      details:
        "Receive expert counseling to select the right program and create a career-focused roadmap. Our guidance ensures students make informed decisions and successfully achieve academic and professional objectives.",
    },
    {
      icon: <FaMoneyBillWave />,
      title: "Affordable Fee Structure",
      details:
        " Pursue higher education without financial burden. Our budget-friendly fees, EMI options, and scholarships make distance education in Bangalore accessible for students from diverse economic backgrounds.",
    },
    {
      icon: <FaHeadset />,
      title: "Ongoing Student Support",
      details:
        " Get continuous support from enrollment to graduation. Our dedicated team assists with course queries, admission procedures, and learning resources, ensuring a smooth experience in Bangalore distance education.",
    },
  ];

  const testimonials = [
    {
      name: "Sumanth R",
      role: "MBA Student",
      message: "Excellent guidance and support throughout the course.",
      img: "/images/stu2.jpg",
    },
    {
      name: "Anjali M",
      role: "BBA Student",
      message: "The faculty is amazing and very helpful.",
      img: "/images/stu1.jpg",
    },
    {
      name: "Ankita G",
      role: "BCA Student",
      message: "I gained practical knowledge that helped me land a job.",
      img: "/images/stu3.jpg",
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000, // delay between auto slides
    speed: 800, // animation duration -> larger = smoother
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    pauseOnHover: true,
    cssEase: "ease-in-out",
    centerMode: true, // optional: centers the active slide
    centerPadding: "0px",
  };

  return (
    <>
      <Helmet>
        <title>
          Bangalore Distance Education | Best Distance Learning Courses
        </title>
        <meta
          name="description"
          content="Enroll in UGC & AICTE-approved distance education in Bangalore. Explore online degree courses & flexible learning from top colleges for career growth."
        />

        {/* ✅ Canonical Tag */}
        <link rel="canonical" href="https://bangaloredistanceeducation.com/" />

        <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
      </Helmet>

      <div style={{ backgroundColor: "#F5F5F5" }}>
        {/* Hero Section */}
        <div className="slider-container">
          <Slider {...settings}>
            {testimonials.map((t, idx) => (
              <div key={idx} style={{ padding: "0 20px" }}>
                <div className="slide-inner">
                  {/* LEFT: Content */}
                  <div className="slide-content">
                    <p>“{t.message}”</p>
                    <h3>{t.name}</h3>
                    <span>{t.role}</span>
                  </div>

                  {/* RIGHT: Image */}
                  <div className="slide-image">
                    <img src={t.img} alt={t.name} />
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
        {/* Features */}
        {/* About Section */}
        <section className="video-about py-5">
          <Container>
            <Row className="align-items-center">
              {/* Left Content */}
              <Col md={6}>
                <p className="video-about-sub">ABOUT US</p>
                <h2 className="video-about-title">
                  Bangalore Distance Education – Flexible Learning for Every
                  Student
                </h2>
                <p className="video-about-desc">
                  At Bangalore Distance Education, we are committed to making
                  quality higher education accessible and flexible for learners
                  from all walks of life. With partnerships across UGC and
                  AICTE-approved universities, we offer a wide range of distance
                  learning courses in Bangalore, including diplomas,
                  undergraduate, and postgraduate degrees. Whether you’re a
                  working professional, a stay-at-home parent, or a recent
                  school graduate, our goal is to help you learn at your own
                  pace without compromising on quality. Backed by expert
                  guidance, student support, and career-focused learning, we are
                  proud to empower students across India to achieve their
                  academic and professional goals from the comfort of home.
                </p>
                <Button
                  variant="primary"
                  size="lg"
                  className="video-about-btn "
                >
                  <Link to="/about" className="text-white">
                    Learn More
                  </Link>
                </Button>
              </Col>

              {/* Right Creative Image */}
              <Col md={6} className="text-center">
                <div className="video-img-wrap">
                  <img
                    src="/images/334746.jpg"
                    alt="A graduate student from Bangalore Distance Education smiling during the campus graduation ceremony."
                    className="img-fluid"
                    // className="video-img"
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        {/* Why Choose Us */}
        {/* Featured Courses */}
        <section className="bp-wrapper">
          <h1 className="mb-5">Featured Courses</h1>

          <div className="bp-container">
            {courses.map((plan) => (
              <div className="bp-card" key={plan.id}>
                <div
                  className="bp-card-header"
                  style={{ backgroundColor: plan.color }}
                ></div>

                <div className="bp-card-body">
                  <h3 className="bp-plan-title">{plan.title}</h3>
                  <p className="bp-plan-text">{plan.description}</p>

                  <Button
                    as={Link}
                    to={`/courses/${plan.title.toLowerCase()}`}
                    variant="dark"
                    className="fw-semibold"
                  >
                    View Course →
                  </Button>
                </div>

                <div
                  className="bp-card-footer"
                  style={{ backgroundColor: plan.color }}
                ></div>
              </div>
            ))}
          </div>
        </section>
        ;
        <section className="why-section">
          <div className="why-head">
            <h1>Why Choose Us</h1>
          </div>
          <div className="why-container">
            {/* Left image */}
            <div className="why-image">
              <img src="/images/whychoose.jpg" alt="Professional" />
            </div>

            {/* Right content */}
            <div className="why-content">
              <p className="section-text">
                Making quality education accessible, flexible, and
                career-focused for learners across India.
              </p>

              <div className="features-grid">
                {features.map((item, idx) => (
                  <div key={idx} className="feature-card">
                    <div className="feature-icon">{item.icon}</div>
                    <div>
                      <h3 className="feature-title">{item.title}</h3>
                      <p className="feature-text">{item.details}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
        <Admission></Admission>
        {/* Register Now */}
        <div className="event-wrapper">
          {/* Curved shape */}
          <div className="curve"></div>

          {/* Left section */}
          <div className="left-section">
            <br />
            <h2>WE APPRECIATE ALL YOU DO</h2>
            <h3>Get Expert Guidance for Your Distance Learning Journey</h3>
            <p>
              Choosing the right course and university can be overwhelming — but
              we’re here to help. At Bangalore Distance Education, our
              experienced counselors are ready to assist you in selecting the
              best-fit program, whether you’re looking to upskill, switch
              careers, or continue your education with distance learning courses
              in Bangalore. Reach out today and take the first step toward a
              brighter, more flexible academic future. We guide you through
              every stage — from course selection to enrollment and beyond. Our
              team ensures a smooth admission process with timely updates and
              responsive support. Let us simplify your path to higher education
              with expert advice you can trust through the best distance
              education colleges in Bangalore.
            </p>
          </div>

          {/* Right section */}
          <div className="right-section">
            <form className="form-card">
              <h2>Registration</h2>
              <hr className="divider" />

              <input type="text" placeholder="Full Name*" />
              <input type="email" placeholder="Email*" />
              <input type="number" name="" id="" placeholder="Phone" />

              <button type="submit" className="register-btn">
                Register
              </button>

              <p className="footer-note">Your perfect events registrations</p>
            </form>
          </div>
        </div>
        {/* Partner Universities */}
        <Partner></Partner>
        {/* Testimonials */}
        <div className="text-center">
          <h1>Testimonial</h1>
        </div>
        <div className="profilecards-container">
          {people.map((p) => {
            const waveColor = getRandomColor();
            return (
              <div className="profilecards-box" key={p.id}>
                {/* Description */}
                <h5>{p.desc}</h5>
                <p className="profilecards-desc">"{p.desc}"</p>

                {/* Avatar */}
                <div className="profilecards-avatar-wrap">
                  <img
                    src={p.img}
                    alt={p.name}
                    className="profilecards-avatar"
                  />
                </div>

                {/* Footer with wave + name + icons */}
                <div className="profilecards-footer">
                  <svg
                    className="profilecards-wave"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 500 150"
                    preserveAspectRatio="none"
                  >
                    <path
                      d="M0.00,49.98 C150.00,150.00 349.20,-49.98 500.00,49.98 L500.00,150.00 L0.00,150.00 Z"
                      style={{ fill: p.color }}
                    ></path>
                  </svg>

                  <div className="profilecards-footer-content">
                    <h3 className="profilecards-name">{p.name}</h3>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        {/* FAQ */}
        <section className="faq-section py-5">
          <Container>
            <Row>
              <h1 className="text-center mb-5">
                Frequently Asked Questions (FAQ)
              </h1>
            </Row>

            <Row>
              {faqData.map((faq, index) => (
                <Col md={6} key={index} className="mb-4">
                  <div
                    className={`faq-card ${
                      openIndex === index ? "active" : ""
                    }`}
                    onClick={() => toggleFAQ(index)}
                  >
                    <div className="faq-question">
                      <span>{faq.question}</span>
                      <span className="faq-icon">
                        {openIndex === index ? <FaMinus /> : <FaPlus />}
                      </span>
                    </div>
                    {openIndex === index && (
                      <div className="faq-answer">{faq.answer}</div>
                    )}
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>
      </div>
    </>
  );
};

export default Home;
